import React from 'react';
import { Grid, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { ConditionPredicate as Comparator } from '@pepperhq/sdk';
import {
    amountComparatorLabel,
    amountComparators,
    ConditionValueValue
} from 'components/campaigns/models/CampaignItem';

interface AmountConditionProps {
    value: ConditionValueValue;
    comparator: Comparator;
    onChange: (value: string, comparator: string) => void;
}

export function AmountCondition(props: AmountConditionProps) {
    const { onChange, value, comparator } = props;
    const options = React.useMemo(
        () => amountComparators.map(item => ({ value: item, label: amountComparatorLabel[item] })),
        []
    );

    const handleComparatorCahnge = React.useCallback(
        (e: SelectChangeEvent) => {
            onChange(String(value), e.target.value);
        },
        [onChange, value]
    );
    const handleValueChange = React.useCallback(
        (e: React.ChangeEvent<{ value: string }>) => {
            onChange(e.target.value, comparator);
        },
        [onChange, comparator]
    );
    return (
        <Grid container spacing={2}>
            <Grid item>
                <Select
                    fullWidth
                    value={comparator ? comparator : Comparator.EQUAL}
                    onChange={handleComparatorCahnge}
                >
                    {options.map(({ value, label }) => (
                        <MenuItem key={`select-amount-comparator-${value}`} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </Select>
            </Grid>
            <Grid item>
                <TextField
                    value={value}
                    placeholder="Input Value"
                    type="number"
                    onChange={handleValueChange}
                />
            </Grid>
        </Grid>
    );
}
